<!-- <p>data-integrations-virtualsensors-manage works!</p> -->
@if (!selectedAccount || !selectedOrganisation || !selectedIntegration) {
<app-loading-template DisplayText="Please wait while we load sensor configuration" />
} @else {
<!-- Add a SideNav Dock Page -->
<app-dock-content>
    <ng-template #navbar class="alignRow">
        <h1>Virtual Sensor Configuration</h1>
        <div class="me-auto"></div>
        <button mat-raised-button (click)="back()" class="app-icon--back">
            <mat-icon />
            <span>Back</span>
        </button>
    </ng-template>

    <ng-template #content>
        <div class="neuron-sensors-configuration">
            <div class="sensor-transfer-container">
                <div class="sensor-list-container">
                    <div class="sensor-list">
                        <ejs-listview #availableSensorList id="availableSensorList" [dataSource]="virtualSensors"
                            showHeader="true" headerTitle="Available Virtual sensors" [fields]="virtualSensorFields"
                            [showCheckBox]="true" [template]="virtualSensorTemplate"
                            (select)="selectVirtualSensor($event)">
                        </ejs-listview>
                    </div>
                </div>

                <!-- Transfer Controls -->
                <div class="sensor-transfer-controls">
                    @if (selectedVirtualSensors.length > 0) {
                    <button mat-icon-button type="button"
                        matTooltip="Add selected Virtual Sensor{{selectedVirtualSensors.length != 1 ? 's' : ''}}"
                        (click)="createWebhookSensorsFromVirtualSensors()">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                    }

                    @if(selectedIntegrationSensors.length > 0) {
                    <button mat-icon-button type="button" (click)="requestDeleteIntegrationSensor()"
                        matTooltip="Remove selected Virtual Sensor{{selectedIntegrationSensors.length != 1 ? 's' : ''}}">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    }
                </div>
                <div class="sensor-list-container">
                    <div class="sensor-list">
                        <ejs-listview #configuredSensorList id="configuredSensorList" [dataSource]="integrationSensors"
                            showHeader="true" headerTitle="Configured Virtual Sensors in {{selectedAccount.Name}}"
                            [fields]="integrationSensorFields" sortOrder="Ascending" [showCheckBox]="true"
                            [template]="integrationSensorTemplate" (select)="selectIntegrationSensor($event)">
                        </ejs-listview>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</app-dock-content>
}

<ng-template #virtualSensorTemplate let-virtualSensor>
    <div class="sensor-list-item">
        <div class="sensor-details">
            <div class="sensor-alias">
                <span>{{ virtualSensor.VirtualSensorName }}</span>
            </div>

            <div class="sensor-description">Input DataPoints: {{ virtualSensor.InputDataPoints }} Calculation: {{
                virtualSensor.Conversion }}</div>
        </div>
    </div>
</ng-template>

<ng-template #integrationSensorTemplate let-integrationSensor>
    <div class="sensor-list-item">
        <div class="sensor-details">
            <div class="sensor-alias">
                <span>{{ integrationSensor.Name }}</span>
            </div>

            <div class="sensor-description">{{ integrationSensor.Description }}</div>
        </div>
    </div>
</ng-template>